/*
 * UpdateBanner — banner flotante que aparece cuando el service worker detecta
 * una versión nueva. Al pulsar "Actualizar" hace SKIP_WAITING + recarga.
 *
 * Escucha el evento `sf:update-available` que emite el bootstrap en index.html
 * cuando el nuevo SW pasa a estado 'installed' y hay controller activo.
 */
import React, { useEffect, useState } from 'react';
import { RefreshCw, X, Sparkles } from 'lucide-react';

const UpdateBanner = () => {
  const [visible, setVisible] = useState(false);
  const [reloading, setReloading] = useState(false);

  useEffect(() => {
    const onUpdate = () => setVisible(true);
    window.addEventListener('sf:update-available', onUpdate);
    return () => window.removeEventListener('sf:update-available', onUpdate);
  }, []);

  const reload = () => {
    setReloading(true);
    try {
      const w = window.__sfWaitingWorker;
      if (w) w.postMessage('SKIP_WAITING');
    } catch { /* noop */ }
    // Salvavidas por si controllerchange no dispara (algunos navegadores)
    setTimeout(() => window.location.reload(), 800);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[10000] px-4"
      data-testid="update-banner">
      <div className="flex items-center gap-3 bg-[#0a0a0a] border border-[#A3FF12]/40 shadow-[0_0_40px_-10px_rgba(163,255,18,0.5)] rounded-2xl px-4 py-3 max-w-md">
        <div className="p-2 bg-[#A3FF12]/10 rounded-lg flex-shrink-0">
          <Sparkles size={18} className="text-[#A3FF12]"/>
        </div>
        <div className="min-w-0 flex-1">
          <div className="text-white font-black text-sm">Hay una versión nueva</div>
          <div className="text-white/50 text-xs">Actualiza para ver los últimos cambios.</div>
        </div>
        <button onClick={reload} disabled={reloading} data-testid="btn-update-reload"
          className="flex items-center gap-1.5 bg-[#A3FF12] text-black font-black px-3 py-2 rounded-xl hover:bg-[#b8ff3a] disabled:opacity-50 text-sm">
          <RefreshCw size={14} className={reloading ? 'animate-spin' : ''}/>
          {reloading ? 'Actualizando…' : 'Actualizar'}
        </button>
        <button onClick={() => setVisible(false)} data-testid="btn-update-dismiss"
          className="text-white/40 hover:text-white p-1 flex-shrink-0" aria-label="Cerrar">
          <X size={16}/>
        </button>
      </div>
    </div>
  );
};

export default UpdateBanner;
